import { Sheet, SheetContent, SheetDescription, SheetTitle, cn, useMediaQuery } from '@blimo/ui';

const WIDTHS = {
  md: 'sm:max-w-md',
  lg: 'sm:max-w-3xl',
};

/**
 * Panel on top of the Radix dialog of @blimo/ui (focus trap, Escape, aria-modal, close button stay intact):
 * phone → drawer from the bottom (rounded top, grabber), from md → side panel on the right.
 *
 * @param {{
 *   open: boolean,
 *   onOpenChange: (open: boolean) => void,
 *   title: import('react').ReactNode,
 *   description?: import('react').ReactNode,
 *   hideTitle?: boolean,
 *   size?: 'md'|'lg',
 *   children: import('react').ReactNode,
 *   className?: string,
 *   bodyClassName?: string,
 * }} props
 */
export function ResponsiveSheet({ open, onOpenChange, title, description, hideTitle = false, size = 'md', children, className, bodyClassName }) {
  const wide = useMediaQuery('(min-width: 768px)', true);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={wide ? 'right' : 'bottom'}
        className={cn('gap-0 overflow-hidden p-0', wide && cn('w-full', WIDTHS[size]), className)}
        {...(description ? {} : { 'aria-describedby': undefined })}
      >
        {!wide && <span className="mx-auto mt-2 block h-1 w-9 shrink-0 rounded-full bg-muted-foreground/30" aria-hidden="true" />}
        <div className={cn('flex shrink-0 flex-col gap-0.5 border-b px-4 pb-3 pr-12', wide ? 'pt-4' : 'pt-2', hideTitle && 'sr-only')}>
          <SheetTitle className="truncate text-base font-semibold">{title}</SheetTitle>
          {description && <SheetDescription className="text-[0.8125rem] text-muted-foreground">{description}</SheetDescription>}
        </div>
        <div className={cn('min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]', bodyClassName)}>{children}</div>
      </SheetContent>
    </Sheet>
  );
}
